module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template) ? _c('document-container', {
    attrs: {
      "footer": _vm.template.footer(),
      "header": _vm.template.header(),
      "logo": _vm.logo,
      "tables": _vm.tables,
      "documentType": "report"
    }
  }, [_vm._l((_vm.template.body()), function(block) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c(block.type, {
      tag: "component",
      attrs: {
        "data": block
      }
    })], 1)
  }), _vm._v(" "), _c('report-base-figures', {
    attrs: {
      "slot": "raw-body",
      "productCurrency": _vm.product.added.productQuotedAs,
      "productPriceAsk": _vm.product.product.figures.productPrice.useAsk,
      "productPriceBid": _vm.product.product.figures.productPrice.useBid,
      "underlyingCurrency": _vm.product.added.underlyingQuotedAs,
      "underlyingPrice": _vm.product.product.figures.underlyingPrice.useLast,
      "underlyingTimestamp": _vm.product.product.figures.underlyingPrice.timestamp
    },
    slot: "raw-body"
  }), _vm._v(" "), _vm._l(([1, 2]), function(type) {
    return _c('product-table-report', {
      key: type,
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body",
        "data": _vm.product,
        "template": _vm.template,
        "type": type
      },
      slot: "raw-body"
    })
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('payback-text-container', {
    attrs: {
      "added": _vm.product.added,
      "product": _vm.product.product
    }
  })], 1), _vm._v(" "), (_vm.chartData) ? _c('report-development', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body",
      "chartData": _vm.chartData,
      "product": _vm.product
    },
    slot: "raw-body"
  }) : _vm._e(), _vm._v(" "), (_vm.tables.findTable('past-events').hasRows()) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table-report-events', {
    attrs: {
      "table": _vm.tables.findTable('past-events')
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tables.findTable('upcoming-events').hasRows()) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table-report-events', {
    attrs: {
      "table": _vm.tables.findTable('upcoming-events')
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.template.config.longDisclaimer && _vm.template.config.longDisclaimer.body.length > 0) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('textblock', {
    attrs: {
      "data": _vm.template.config.longDisclaimer
    }
  })], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a948d52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Report.vue
// module id = 700
// module chunks = 0